// Export range configuration for Windows page
export const WINDOWS_EXPORT_RANGE = [0, 9999];
